import type { OS } from '@tunasong/ui-lib'

const keyNames: Record<string, string> = {
  ctrl: 'Control',
  shift: 'Shift',
  alt: 'Alt',
  opt: 'Alt',
  meta: 'Meta',
  enter: 'Enter',
}

/** Spell a hotkey ('shift+mod+f') as an aria-keyshortcuts value ('Shift+Meta+F'), resolving mod per platform. */
export const toAriaKeyShortcuts = (hotkey: string, os: OS) =>
  hotkey
    .split('+')
    .map(key => {
      if (key === 'mod') {
        return os === 'mac' || os === 'ios' ? 'Meta' : 'Control'
      }
      return keyNames[key] ?? key.toUpperCase()
    })
    .join('+')
